<div
  class="selectable-card"
  [ngClass]="{'selectable-card--selected': selected, 'selectable-card--wider': wider}">
  <span>{{text}}</span>
</div>
